export const DEVICE_MODEL = {
  A3700: 'A3700',
  A800: 'A800',
  A920: 'A920',
  A930: 'A930',
  E700: 'E700',
  ELO: 'ELO',
  L1400: 'L1400',
  Q20: 'Q20',
  Q25: 'Q25',
  WEB: 'web',
}
